// saveMatchResults.js
import { debounce } from "lodash";

// Debounced saver (adjust delay if needed)
const debouncedSaveResults = debounce((resultsID, newResults, saveResults) => {
  console.log("💾 Debounced saveResults triggered with:", {
    resultsID,
    newResults,
  });
  saveResults(resultsID, newResults);
}, 400);

const saveMatchResults = (matchId, updatedUserModified, setData, saveResults) => {

  let newResultsRef = null;
  let resultsIDRef = null;

  setData((prev) => {
    if (!prev) {
      console.warn("⚠️ prev is null/undefined, returning early");
      return prev;
    }

    // Only update the specific result that matches matchId
    const newResults = prev.results.map((result) => {
      if (result.id !== matchId) return result; // leave others untouched
      const updatedMatches = result.Matches.map((matchObj) => {
        const key = Object.keys(matchObj)[0];
        const match = matchObj[key];
        const existingUserModified = match["User Modified"] || {};

        const mergedUserModified = {
          ...existingUserModified,
          Notes: updatedUserModified.Notes ?? existingUserModified.Notes,
          MarkForExport:
            updatedUserModified.MarkForExport ??
            existingUserModified.MarkForExport,
          doc1: updatedUserModified.doc1 ?? existingUserModified.doc1,
          doc2: updatedUserModified.doc2 ?? existingUserModified.doc2,
        };


        return {
          [key]: {
            ...match,
            "User Modified": mergedUserModified,
          },
        };
      });

      const updatedResult = { ...result, Matches: updatedMatches };
      return updatedResult;
    });

    newResultsRef = newResults;
    resultsIDRef = prev.resultsID;

    const finalData = { ...prev, results: newResults };

    return finalData;
  });

  // Trigger save AFTER state updates, with debounce
  setTimeout(() => {
    if (newResultsRef && resultsIDRef) {
      debouncedSaveResults(resultsIDRef, newResultsRef, saveResults);
    } else {
      console.warn("⚠️ saveResults skipped: no resultsRef available");
    }
  }, 0);
};

export default saveMatchResults;
